import { Component, OnInit, Input, Output } from '@angular/core';
import { FileuploadService } from './fileupdate.service';
import { NotificationService, LoaderService, CONSTANT, UtilityService } from '../session';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-fileupload',
  templateUrl: 'fileupload.component.html',
  styleUrls: ['fileupload.component.css']
})

export class FileuploadComponent implements OnInit {
  public isUploadBtn: boolean = true;
  private msgErrorInsert: string = 'Error al insertar imagen';
  private msgErrorLoad: string = 'Error al cargar imagen';
  private msgErrorDelete: string = 'Error al eliminar imagen';
  private msgErrorObtener: string = 'Error al obtener imagen';
  private imageUrlDefault: string = CONSTANT.pathFileUpload.imageDefault;
  private isChanged: boolean;

  @Input() imageUrl: string;
  @Input() typeImage: number;
  @Output() imageName: string;
  public imageFile64: any;
  public imageFile: any;

  constructor(
    private fileuploadService: FileuploadService,
    private notificationService: NotificationService,
    private loaderService: LoaderService,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    if (this.typeImage)
      this.typeImage == CONSTANT.typeImage.view;

    this.isChanged = false;
    //this.getFile("","", "");
  }

  fileChange(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.loaderService.show();
      let file: File = fileList[0];
      this.loadFile(file);
      this.isChanged = true;
      event.srcElement.value = null;
    }
  }

  public insertFile(clase: string, tipo: string, pathAnterior: string = "", codigo: string) {
    if (!this.imageName) {
      this.deleteFile(pathAnterior);
      return;
    }

    if (!this.isChanged)
      return;

    let file: File;
    file = this.imageFile;

    let ext: string = this.imageName.substring(this.imageName.lastIndexOf('.'));
    this.imageName = this.utilityService.getMomentString() + codigo.trim();
    this.imageName = this.imageName + ext;
    this.fileuploadService.fileuploadInsertar(file, this.imageName, clase, tipo)
      .subscribe(res => {
      },
        error => {
          this.notificationService.error(error.error.error || this.msgErrorInsert);
          throw error;
        },
        () => {
          if (pathAnterior != "")
            this.deleteFile(pathAnterior);
        });
  }

  public deleteFile(imageUrl: string) {
    if (imageUrl != "") {
      this.fileuploadService.fileuploadDelete(imageUrl)
        .subscribe(res => {
        },
          error => {
            this.notificationService.error(this.msgErrorDelete);
            throw error;
          },
          () => {
          });
    }
  }

  public getFile(clase: string, tipo: string, imageUrl: string) {
    if (imageUrl != "") {
      this.loaderService.show();
      this.fileuploadService.fileuploadGet(imageUrl)
        .subscribe(res => {
          this.loadFile(res, imageUrl);
        },
          error => {
            this.notificationService.error(this.msgErrorObtener);
            throw error;
          },
          () => {
            this.loaderService.hide();
          });
    }
  }

  clearFile() {
    this.imageUrl = this.imageUrlDefault;
    this.imageFile64 = null;
    this.imageFile = null;
    this.imageName = '';
    this.getFile('', '', '');
  }

  loadFile(file: File, pathURL: string = '') {
    this.imageFile = file;
    if (file.name)
      this.imageName = file.name;
    else
      this.imageName = pathURL.substring(pathURL.lastIndexOf('\\') + 1, pathURL.length);

    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      this.imageFile64 = String(reader.result);
    }
    this.loaderService.hide();
  }
}
